<kve-editor-content-cell>
    <div class="content-cell">
        <div class="input-cell">
            <nb-toggle  [checked]="true" labelPosition="start">Shipping Rates & Policies</nb-toggle>
        </div>
        <div class="input-cell">    
            <nb-toggle [checked]="true" labelPosition="start">Returns & Replacements</nb-toggle>
        </div>
    </div>
</kve-editor-content-cell>
